var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative flex-grow-1 col-12 tournament-participants"},[_c('Widget',{staticClass:"mb-5",attrs:{"title":_vm.$$t('Participants Applications', 'applications-list')},on:{"input":_vm.onFilterChange},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),(_vm.showStub)?_c('HeraDummyList',{staticClass:"mt-4",attrs:{"size":"200","icon-name":"dummy/members","header-text":_vm.$$t('You have no participants yet', 'grid_empty')}}):_c('div',{staticClass:"tournament-participants-list mt-5"},[_c('Paginated',_vm._b({staticClass:"mb-5",on:{"change":_vm.fetchList}},'Paginated',{
        totalItems: _vm.totalItems,
        hidePagination: !_vm.players.length,
        pageSize: _vm.pageSize,
        inContainer: true,
      },false),[_c('Table',{staticClass:"all-participants-table mb-5 col",attrs:{"columns":_vm.visibleColumns,"items":_vm.players,"loading":_vm.isLoading,"max-items-length":_vm.totalItems,"dummy-props":{
          size: 200,
          iconName: 'dummy/members',
          headerText: _vm.$t(
            '_web_tournament_players_empty',
            'You have no participants yet'
          ),
        }},scopedSlots:_vm._u([{key:"head-item",fn:function(ref){
        var column = ref.column;
return [_c('PlayersTableHeadCell',{attrs:{"column-name":column.name,"sort-icon":_vm.sortFields.field !== _vm.transformField(column.name)
                ? 'sort'
                : _vm.sortFields.order === 'incr'
                ? 'sort-asc'
                : 'sort-dsc'},on:{"sort":_vm.handleSort}})]}},{key:"body-item",fn:function(ref){
                var item = ref.item;
                var column = ref.column;
return [_c('PlayersTableCell',{attrs:{"column-name":column.name,"column-label":column.label,"row":item},on:{"chat":_vm.startChat}})]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }